module.exports = __webpack_public_path__ + "static/media/hand_burst.d30607ef.jpeg";